import PropTypes from "prop-types";
import { IYxrequest } from "../../utils/propType";
import { IYxPanelPropTypes } from "../YxPanel";

const ITypeInput = PropTypes.oneOf([
  "Number",
  "String",
  "TextInput",
  "Date",
  "Phone",
  "Password",
  "Certificates",
  "Select",
  "TreeSelect",
  "EMail",
  "Url",
  "Range",
  "Cascader",
  "YxPopup",
  "Radio",
  "YxRadio",
  "Switch",
  "TextArea",
  "Upload",
  "Checkbox",
  "KindEditor",
  "Search",
  "Extend",
  "ColorPicker",
  "IncrementForm",
  "YxCode",
]);

//表单组件项类型
export const IcontrolListItem = PropTypes.shape({
  // input 组件类型
  type: ITypeInput,

  coordinate: PropTypes.any,

  //控件项的详细参数，即YxInput的公共参数及子组件参数， 具体请参考它的参数表YxInput
  controlItemParam: PropTypes.object,

  //(val,key,data)= result 反序列化时，处理数值的函数，
  //如有函数则只处理函数，必须要返回内容，会传递3个参数，key对应的值，key，以及整个查询到的data对象
  deserializeCallback: PropTypes.func,

  //表单互斥对象，
  mutex: PropTypes.shape({
    //要监听的控件的id，当form设置了groupKey时，id前面要加上groupKey的值，
    //例：groupKey='form1', ids: ['form1.id']
    ids: PropTypes.array,

    formId: PropTypes.any,

    //控件项值发生变更时的回调函数, 返回所有监听对象的id和值，如果返回false，则该项控件将不显示
    callback: PropTypes.func,
  }),
  children: PropTypes.node,
});

const IformRow = PropTypes.shape({
  //行的参数， 详见antd的row参数表
  rowParam: PropTypes.object,

  // 行的列信息
  col: PropTypes.arrayOf(
    PropTypes.shape({
      //作用在列的参数，详细参数请参考antd-grid-col
      colParam: PropTypes.object,

      //input 控件的多语言类型， 默认是输入框模式
      controlType: PropTypes.string,

      //列的多语言类型  如果等于multiple ， 整列就会变成多语言
      colType: PropTypes.string,

      //列的节点信息，如果有该字段，则controlList字段失效
      children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

      controlList: PropTypes.arrayOf(IcontrolListItem),
    })
  ),
});
//操作按钮类型
const IoperatingBtnItem = PropTypes.shape({
  //操作项的接口操作，如果有该参数，接口在点击后会发起请求
  requestParam: IYxrequest,

  //{string | array} whole | [inputIds]
  // 提交范围，如果是whole则会把所有分组一起提交，如果是数组，则只提交该数组指定的id项
  submitRange: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

  /*.... 其他参数为 YxAction*/
});
const IFormPropItem = PropTypes.shape({
  //是否禁用所有表单项
  inputDisabled: PropTypes.bool,

  //直接作用在Form组件上的参数，详情请参见 antd-form
  formParam: PropTypes.object,

  groupParam: PropTypes.shape({ groupParam: PropTypes.bool }),

  //分组id
  groupKey: PropTypes.string,

  //操作项
  operating: PropTypes.shape({
    //是否为主面板的操作按钮，如果true，则出现在主面板上
    isMain: PropTypes.bool,

    buttonList: PropTypes.arrayOf(IoperatingBtnItem),
  }),

  //表单的行信息
  row: PropTypes.arrayOf(IformRow),
});

const IYxFormParam = {
  // renderingEndCallback {function([buttonIdArray])} 控件渲染完毕后，会返回所有控件的id列表
  renderingEndCallback: PropTypes.func,

  // 表单初始的的请求的参数，有该参数时，既为编辑状态表单，请求后的结果将自动反序列化，详见request函数
  requestParam: IYxrequest,

  //(val,id,event,eventData)=>{}表单控件值发生变化时的回调函数，返回控件值，以及控件id,当前对象，当前对象的所有信息
  change: PropTypes.func,

  //表单初始需要反序列化的对象
  deSerializationData: PropTypes.object,

  //类似change事件，但会返回整个表单的值
  onFormChange: PropTypes.func,

  //  赋值前调用回调用函数
  setFieldsValueBefore: PropTypes.func,

  //面板参数类型
  panelParam: PropTypes.shape(IYxPanelPropTypes),

  //主表单的标题
  pageTitle: PropTypes.node,

  //隐藏label 的冒号：
  noSymbol: PropTypes.bool,

  //加载完成初始化方法 暴露内部信息
  load: PropTypes.func,

  //版本号，如果版本号发生变更，会重新请求接口进行反序列化
  version: PropTypes.string,

  //是否弹性布局，默认不启用，固定宽度
  isGrid: PropTypes.bool,

  //平铺式表单项，它的值即普通表单项的所有参数
  formItemList: PropTypes.arrayOf(IcontrolListItem),

  //平铺式参数项的的具体参数，可以是任意参数
  formItemParamList: PropTypes.arrayOf(
    PropTypes.shape({
      //平铺式参数项的坐标, 必须是  0-0-0 格式， 可以写任意位数，代表了 表单索引-行索引-列索引
      coordinate: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

      //平铺式参数项的的具体参数，可以是任意参数
      param: PropTypes.object,
    })
  ),

  // 表单信息
  form: PropTypes.arrayOf(IFormPropItem),
};

export const YxDynamicFormPropTypes = {
  //子节点
  children: PropTypes.node,

  //是否显示拖拽提示
  isDragTips: PropTypes.bool,

  //
  formParam: PropTypes.shape(IYxFormParam),
};



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxDynamicForm/IpropType.js